import { PlanningMeasurementRequest, PlanningRequestWafer } from "@/types/planning";
import { WaferStatus } from "@/types/measurementRequest";

export type PlanningTab = "PLANNING" | "PROCESSING" | "HISTORY";

export function isRequestFullyBacklogged(request: PlanningMeasurementRequest): boolean {
  const progress = request.waferProgress;
  return Boolean(
    progress && progress.backlog > 0 && progress.scheduled === 0 && progress.measured === 0,
  );
}

export const planningStatusesByTab: Record<PlanningTab, readonly WaferStatus[]> = {
  PLANNING: ["SCHEDULED", "TO_SCHEDULE"],
  PROCESSING: ["MEASURING", "ANALYSING", "MEASURED"],
  HISTORY: ["ANALYSED", "MEASURING_FAILED", "ANALYSIS_FAILED"],
};

export function groupPlanningRequests(
  requests: PlanningMeasurementRequest[],
  measurementSystemId: number,
) {
  const groups: Record<
    "backlog" | "planning" | "processing" | "history",
    PlanningMeasurementRequest[]
  > = { backlog: [], planning: [], processing: [], history: [] };

  requests.forEach((request) => {
    const wafersByGroup: Record<keyof typeof groups, PlanningRequestWafer[]> = {
      backlog: [],
      planning: [],
      processing: [],
      history: [],
    };

    request.waferRequests.forEach((wafer) => {
      if (wafer.status === "TO_SCHEDULE") {
        wafersByGroup.backlog.push(wafer);
        return;
      }
      if (measurementSystemId !== 0 && wafer.measurementSystem?.id !== measurementSystemId) {
        return;
      }

      switch (wafer.status) {
        case "SCHEDULED":
          wafersByGroup.planning.push(wafer);
          break;
        case "MEASURING":
        case "ANALYSING":
        case "MEASURED":
          wafersByGroup.processing.push(wafer);
          break;
        case "MEASURING_FAILED":
        case "ANALYSIS_FAILED":
        case "ANALYSED":
          wafersByGroup.history.push(wafer);
          break;
      }
    });

    const groupNames: (keyof typeof groups)[] = ["backlog", "planning", "processing", "history"];
    groupNames.forEach((group) => {
      if (wafersByGroup[group].length > 0) {
        groups[group].push({ ...request, waferRequests: wafersByGroup[group] });
      }
    });
  });

  return groups;
}
